// Mock data for Peace of Mind Property Management website

export const companyInfo = {
  name: "Peace of Mind",
  tagline: "POM Property Management",
  location: "Puerto Plata & Las Terrenas, DR",
  phone: "+1 (829) 285-2485",
  email: "hola@pom-pm.com",
  logo: "https://customer-assets.emergentagent.com/job_c46fcb94-cd59-4f0e-863c-2f57b5de0e04/artifacts/j3ya7gn7_POM%20logo%20no%20background.png",
  description: "Local experts with 20+ years in the luxury vacation business. Fluent team in English, Spanish, and French."
};

export const heroImages = {
  beach: "https://customer-assets.emergentagent.com/job_7b49076b-2ea7-472c-9547-3511a8da7d76/artifacts/nvje680p_plaj%20%28Instagram%20Post%29.png",
  bougainvillea: "https://customer-assets.emergentagent.com/job_7b49076b-2ea7-472c-9547-3511a8da7d76/artifacts/btdvlmvh_boug2.jpeg",
  hibiscus: "https://customer-assets.emergentagent.com/job_7b49076b-2ea7-472c-9547-3511a8da7d76/artifacts/ei4l6sqy_hibiscus.jpeg"
};

export const packages = [
  {
    id: 1,
    name: "Essential Care Package",
    target: "For Absentee Homeowners",
    icon: "Home",
    features: [
      "Bill payments (utilities, HOA, taxes)",
      "Monthly Deep Cleaning",
      "Emergency contact for property issues",
      "Monthly property inspection & report",
      "Key holding service",
      "Airport Transfer from POP (Special Promo)"
    ],
    highlight: "Perfect for 2-3 bedroom homes"
  },
  {
    id: 2,
    name: "Rental Management Package",
    target: "For Short-term Rentals & Airbnb Hosts",
    icon: "Building",
    features: [
      "Everything in Essential Care, plus:",
      "Airbnb/Booking.com/VRBO listing management",
      "Guest communication & support",
      "Check-in & check-out service",
      "Professional cleaning & turnover",
      "Guest welcome kit",
      "24/7 guest support hotline"
    ],
    highlight: "Elevate to SuperHost status"
  },
  {
    id: 3,
    name: "Premium Concierge Package",
    target: "For Luxury & High-end Rentals",
    icon: "Crown",
    features: [
      "Everything in Rental Management, plus:",
      "Airport pick-up/drop-off coordination",
      "Stocking groceries & supplies",
      "Excursions, tours & car rentals",
      "On-call handyman services",
      "VIP guest concierge services",
      "Restaurant, private chef & spa bookings"
    ],
    highlight: "White-glove service experience"
  }
];

export const aLaCarteServices = [
  { name: "Deep Cleaning", icon: "Sparkles" },
  { name: "Airport Transfers", icon: "Plane" },
  { name: "Pool Maintenance", icon: "Waves" },
  { name: "Lawn & Garden Service", icon: "TreePalm" },
  { name: "Pest Control", icon: "Bug" },
  { name: "Expenses Tracking", icon: "Calculator" }
];

export const features = [
  {
    icon: "Globe",
    title: "Multilingual Team",
    description: "Fluent in English, Spanish, and French"
  },
  {
    icon: "BadgeCheck",
    title: "No Gringo Taxes",
    description: "Fair, transparent pricing for everyone"
  },
  {
    icon: "Clock",
    title: "20+ Years Experience",
    description: "Local experts in luxury vacation business"
  },
  {
    icon: "Sparkles",
    title: "Sparkly Clean",
    description: "No cutting corners on quality"
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "Top 10 Hidden Beaches in Puerto Plata",
    excerpt: "Discover secluded paradises away from the tourist crowds. From pristine shores to crystal-clear waters...",
    image: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=800",
    date: "August 15, 2025",
    category: "Beaches"
  },
  {
    id: 2,
    title: "A Food Lover's Guide to Dominican Cuisine",
    excerpt: "From sancocho to mangu, explore the rich flavors of Dominican cooking and where to find the best local dishes...",
    image: "https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=800",
    date: "August 12, 2025",
    category: "Food & Culture"
  },
  {
    id: 3,
    title: "The 27 Waterfalls of Damajagua",
    excerpt: "Adventure awaits at this stunning natural wonder. Learn how to plan your perfect waterfall adventure...",
    image: "https://images.unsplash.com/photo-1432405972618-c60b0225b8f9?w=800",
    date: "August 8, 2025",
    category: "Adventures"
  },
  {
    id: 4,
    title: "Puerto Plata's Historic Teleférico",
    excerpt: "Ride the only cable car in the Caribbean and enjoy breathtaking views of the Atlantic Ocean...",
    image: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800",
    date: "August 5, 2025",
    category: "Attractions"
  }
];

export const dominicanSlangWords = [
  {
    word: "¡Qué lo que!",
    pronunciation: "keh loh keh",
    meaning: "What's up? / How are you?",
    example: "¡Qué lo que, mi pana! - What's up, my friend!",
    funFact: "This is the most common Dominican greeting you'll hear everywhere!"
  },
  {
    word: "Tigueraje",
    pronunciation: "tee-gweh-RAH-heh",
    meaning: "Street smarts / Cunning behavior",
    example: "Ese tipo tiene mucho tigueraje - That guy has lots of street smarts",
    funFact: "Comes from 'tigre' (tiger), symbolizing someone clever and resourceful."
  },
  {
    word: "Vaina",
    pronunciation: "VAI-nah",
    meaning: "Thing / Stuff / Situation",
    example: "¿Qué vaina es esa? - What thing is that?",
    funFact: "The most versatile Dominican word! Can mean literally anything."
  },
  {
    word: "Chin",
    pronunciation: "cheen",
    meaning: "A little bit",
    example: "Dame un chin de agua - Give me a little water",
    funFact: "Short for 'chiquito' (small), used constantly in daily conversation."
  },
  {
    word: "Guagua",
    pronunciation: "GWA-gwa",
    meaning: "Bus / Public transportation",
    example: "Voy a coger la guagua - I'm going to take the bus",
    funFact: "In other Latin countries, 'guagua' means baby! Don't get confused!"
  },
  {
    word: "Colmado",
    pronunciation: "kol-MAH-doh",
    meaning: "Corner store / Small grocery shop",
    example: "Voy al colmado por una fría - Going to the store for a cold beer",
    funFact: "The heart of Dominican neighborhoods - where everyone meets and greets!"
  },
  {
    word: "Tato",
    pronunciation: "TAH-toh",
    meaning: "Okay / Alright / Deal",
    example: "¿Nos vemos a las 8? - Tato! - See you at 8? - Alright!",
    funFact: "Short for 'está todo bien' (everything's good). Super casual!"
  },
  {
    word: "Pana",
    pronunciation: "PAH-nah",
    meaning: "Friend / Buddy",
    example: "Él es mi pana del alma - He's my best buddy",
    funFact: "Comes from the word 'partner' - your trusted companion!"
  },
  {
    word: "Motoconcho",
    pronunciation: "moh-toh-KON-choh",
    meaning: "Motorcycle taxi",
    example: "Voy a coger un motoconcho - I'll take a motorcycle taxi",
    funFact: "The fastest (and most adventurous) way to get around Dominican towns!"
  },
  {
    word: "Chepa",
    pronunciation: "CHEH-pah",
    meaning: "Good luck / Lucky break",
    example: "¡Qué chepa que encontraste parking! - How lucky you found parking!",
    funFact: "Originally means the hump of an animal - associated with good fortune!"
  },
  {
    word: "Pariguayo",
    pronunciation: "pah-ree-GWA-yoh",
    meaning: "Party pooper / Someone uncool",
    example: "No seas pariguayo, ven a la fiesta - Don't be lame, come to the party",
    funFact: "Allegedly comes from 'party watcher' - someone who just watches!"
  },
  {
    word: "Coro",
    pronunciation: "KOH-roh",
    meaning: "Hangout / Party / Good time",
    example: "¿Dónde es el coro esta noche? - Where's the party tonight?",
    funFact: "Literally means 'chorus' but Dominicans use it for any fun gathering!"
  },
  {
    word: "Klk",
    pronunciation: "keh-loh-keh",
    meaning: "Text version of 'Qué lo que'",
    example: "Klk, como tu ta? - Hey, how are you?",
    funFact: "The unofficial Dominican texting language - you'll see it everywhere online!"
  },
  {
    word: "Ta' to'",
    pronunciation: "tah-TOH",
    meaning: "Everything's good / All set",
    example: "¿Ya terminaste? - Sí, ta' to' - You done? - Yeah, all good",
    funFact: "Shortened from 'está todo' - Dominicans love abbreviating!"
  }
];

export const testimonials = [
  {
    name: "Sarah M.",
    location: "New York, USA",
    text: "POM has been managing our vacation property for 2 years now. Absolutely stress-free experience!",
    rating: 5
  },
  {
    name: "Jean-Pierre L.",
    location: "Montreal, Canada",
    text: "Their multilingual team made everything so easy. The monthly reports are incredibly detailed.",
    rating: 5
  },
  {
    name: "Michael R.",
    location: "London, UK",
    text: "From cleaning to guest management, they handle everything professionally. Highly recommend!",
    rating: 5
  }
];
